import type { CSSProperties } from 'react'
import type { Loan } from '@/types'
import type { ColumnDef } from './columnTypes'
import { ResponsiblePartyCell } from './ResponsiblePartyCell'

/** One assignment control for live pipeline tables; reports/print use names. */
export function PipelineTableCell({
  column,
  loan,
  editableResponsibleParty = false,
  presentation = 'grid',
  selectStyle,
}: {
  column: ColumnDef
  loan: Loan
  editableResponsibleParty?: boolean
  presentation?: 'grid' | 'report'
  selectStyle?: CSSProperties
}) {
  if (column.id === 'assignee' && editableResponsibleParty) {
    return <>
      <div className="w-full print:hidden">
        <ResponsiblePartyCell
          loan={loan}
          selectStyle={selectStyle}
          selectClassName={presentation === 'report'
            ? 'h-4 w-full min-w-[120px] rounded border border-current bg-transparent px-1 text-center text-inherit outline-none focus-visible:ring-1 focus-visible:ring-current disabled:opacity-60'
            : undefined}
        />
      </div>
      <span className="hidden print:inline">{column.display(loan)}</span>
    </>
  }
  return <>{presentation === 'report' ? column.display(loan) : column.render(loan)}</>
}
